/**
 * The UI language, sent as Accept-Language with every API request so questions, reports and
 * error messages come back in it. Its own module so tests that mock the API client keep it.
 */
let requestLocale: 'en' | 'hi' = 'en';
export const setRequestLocale = (locale: 'en' | 'hi') => {
  requestLocale = locale;
};
export const getRequestLocale = () => requestLocale;
